/** CoStar.Api.MessageDelivery.Models.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["None"] = 0] = "None";
    SortType[SortType["Email"] = 1] = "Email";
    SortType[SortType["IP"] = 1] = "IP";
    SortType[SortType["CreateDate"] = 2] = "CreateDate";
})(SortType || (SortType = {}));
import { SortOrder } from "../../../../CoStar/Api/AptsAnalytics/ViewModels/index.js";
/** CoStar.Api.MessageDelivery.Models.SortOrder */
export { SortOrder };
